import * as React from "react";
import { Context } from "./_context";
export const ScrubberIcon = ({ size = 24, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[24] = /* @__PURE__ */ React.createElement("svg", { width: "1.5rem", height: "1.5rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "m16.707 18.707-4 4a1 1 0 0 1-1.414 0l-4-4 1.414-1.414L12 20.586l3.293-3.293 1.414 1.414ZM11.293 1.293a1 1 0 0 1 1.414 0l4 4-1.414 1.414L12 3.414 8.707 6.707 7.293 5.293l4-4Z", fill: "currentColor" }));
  return iconset[size];
};
ScrubberIcon.iconId = "boAmos";
